export default "__VITE_ASSET__CBFQSBM3__"